export const audiencePopoverOptions = {
  className: "audience-popover",
  popperClassName: "audience-popper",
  placement: "top",
  fade: true,
  flip: false,
  trigger: "focus"
};

export const headerPopoverOptions = {
  className: "header-popover",
  popperClassName: "header-popper",
  placement: "bottom-start",
  hideArrow: true,
  fade: true,
  modifiers: { flip: { enabled: true } },
  flip: true
};

export const defaultOptions = {
  className: "idfree-popover",
  popperClassName: "idfree-popper",
  placement: "auto",
  fade: true,
  flip: false,
  trigger: "legacy"
};
